/* eslint-disable import/no-namespace */
import { initialuserstate } from '../initialuserstate'
import * as types from '../actions'

export default function user (state=initialuserstate,action){
 
  switch (action.type) {
        
  case types.user.GET_USER_ROLE:
  {                 
    const isAdministrator = action.payload.data
    return Object.assign({},state,{ isAdministrator })         
  }
  case types.user.SET_USER_ROLE:
  {
    const isAdministrator = action.payload.isAdmin
    return Object.assign({},state,{ isAdministrator, roleChecked:true }) 
  }
  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_user.js